import Axios from "axios";
var PurchaseService = (function () {
    function PurchaseService() {
    }
    PurchaseService.prototype.getList = function (params) {
        return Axios.get("supplierclientapi/upperwarehouse/list", { params: params });
    };
    PurchaseService.prototype.getListGoods = function (params) {
        return Axios.get("supplierclientapi/upperwarehouse/list_goods", { params: params });
    };
    PurchaseService.prototype.getDetail = function (params) {
        return Axios.get("supplierclientapi/upperwarehouse/detail", { params: params });
    };
    PurchaseService.prototype.addUpperwarehouse = function (params) {
        return Axios.post("supplierclientapi/upperwarehouse/create", params);
    };
    PurchaseService.prototype.updateUpperwarehouse = function (params) {
        return Axios.post("supplierclientapi/upperwarehouse/update", params);
    };
    PurchaseService.prototype.getSupplierdepotList = function (params) {
        return Axios.get("supplierclientapi/supplierdepot/list", { params: params });
    };
    PurchaseService.prototype.audit = function (params) {
        return Axios.get("supplierclientapi/upperwarehouse/audit", { params: params });
    };
    PurchaseService.prototype.discard = function (params) {
        return Axios.get("supplierclientapi/upperwarehouse/cancel", { params: params });
    };
    PurchaseService.prototype.create = function (params) {
        return Axios.get("supplierclientapi/supplierdepot/list", { params: params });
    };
    PurchaseService.prototype.getOrgandepotOptions = function (params) {
        return Axios.get("supplierclientapi/supplierdepot/get_organdepot_options", { params: params });
    };
    PurchaseService.prototype.getSupplierupperOptions = function (params) {
        return Axios.get("supplierclientapi/supplierupper/get_options", { params: params });
    };
    PurchaseService.prototype.getAccountOptions = function (params) {
        return Axios.get("supplierclientapi/account/get_options", { params: params });
    };
    PurchaseService.prototype.getSupplierorganOptions = function (params) {
        return Axios.get("supplierclientapi/supplierorgan/get_options", { params: params });
    };
    PurchaseService.prototype.getSupplierdepotOptions = function (params) {
        return Axios.get("supplierclientapi/supplierdepot/get_options", { params: params });
    };
    PurchaseService.prototype.getStockinitGoodslist = function (params) {
        return Axios.post("supplierclientapi/upperwarehouse/get_goods_list", params);
    };
    PurchaseService.prototype.deleteStockinitGoodslist = function (params) {
        return Axios.get("supplierclientapi/upperwarehouse/delete_detail", { params: params });
    };
    PurchaseService.createInstance = function () {
        PurchaseService.getInstance();
    };
    PurchaseService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    return PurchaseService;
}());
export default PurchaseService;
